import { render, staticRenderFns } from "./copyrightRegistrationYuDengji.vue?vue&type=template&id=21ad08a4&scoped=true&"
import script from "./copyrightRegistrationYuDengji.vue?vue&type=script&lang=js&"
export * from "./copyrightRegistrationYuDengji.vue?vue&type=script&lang=js&"
import style0 from "./copyrightRegistrationYuDengji.vue?vue&type=style&index=0&lang=less&"
import style1 from "./copyrightRegistrationYuDengji.vue?vue&type=style&index=1&id=21ad08a4&lang=less&scoped=true&"
import style2 from "./copyrightRegistrationYuDengji.vue?vue&type=style&index=2&id=21ad08a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad08a4",
  null
  
)

export default component.exports